export default __webpack_public_path__ + "static/media/back.34bcde48.png";